import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LoadingButton, type LoadingButtonProps } from '@mui/lab';
import { Button, Typography } from '@mui/material';

import { ModalSidebar, ModalSidebarActions, ModalSidebarAdditional } from '@/components/Modal';

import type { NomenclatureFormProps } from './NomenclatureForm';
import { NomenclatureModalInfo } from './NomenclatureModalInfo';

// ----------------------------------------------------------------------

export type NomenclatureModalSidebarProps = {
  isEditMode: boolean;
  onCancel: VoidFunction;
  drug: NomenclatureFormProps['drug'];
  formId?: LoadingButtonProps['form'];
};

// ----------------------------------------------------------------------

export const NomenclatureModalSidebar = (props: NomenclatureModalSidebarProps) => {
  const { drug, onCancel, isEditMode, formId } = props;
  const { t } = useTranslation('nomenclature-page');

  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <ModalSidebar sx={{ height: '100%' }}>
      <NomenclatureModalInfo isEditMode={isEditMode} drug={drug} />

      <ModalSidebarAdditional>
        <Typography component="p" variant="caption" color="text.secondary">
          <Typography component="span" variant="inherit" color="error.main">
            *
          </Typography>{' '}
          - {t('modals.form.required-fields')}
        </Typography>
      </ModalSidebarAdditional>

      <ModalSidebarActions>
        <Button fullWidth variant="outlined" color="inherit" onClick={onCancel}>
          {t('modals.form.actions.cancel')}
        </Button>
        <LoadingButton
          fullWidth
          loading={isSubmitting}
          form={formId}
          type="submit"
          variant="contained"
          color="secondary"
        >
          {t('modals.form.actions.apply')}
        </LoadingButton>
      </ModalSidebarActions>
    </ModalSidebar>
  );
};
